import React from 'react';
import { bindActionCreators } from "redux";
import { tokenAction } from "../../redux-stuffs/actions/token_action";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { accessTokenState } from '../../atoms';
import withRecoil from '../../withRecoil';
import api from '../../api/api';
import DOMPurify from "dompurify";
import { colors } from '../Colors';
import Pagination from '../Pagination';
// import Header from "../../components/Header"; // still unused here

class FAQ extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      faqs: [],
      loading: true,
      error: null,
      currentPage: 1,
      pageSize: 10,
    };
  }

  componentDidMount() {
    // Fetch FAQs from backend API
    fetch(`${api.extra}/api/faq?access_token=${this.props.recoilStates.accessTokenState.state}`)
      .then(response => response.json())
      .then(data => {
        this.setState({
          faqs: Array.isArray(data.faq) ? data.faq : [],
          loading: false,
          currentPage: 1, // reset to first page on load
        });
      })
      .catch(() => {
        this.setState({ error: "Failed to load FAQ", loading: false });
      });
  }

  decodeHTML = (html) => {
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    return txt.value;
  };

  goToPage = (page) => {
    this.setState(
      (prev) => {
        const totalPages = Math.max(1, Math.ceil(prev.faqs.length / prev.pageSize));
        const next = Math.min(Math.max(1, page), totalPages);
        return { currentPage: next };
      },
      () => {
        // optional smooth scroll to top of the FAQ container
        try {
          document.querySelector('.faq-container')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch {}
      }
    );
  };

  render() {
    const { faqs, loading, error, currentPage, pageSize } = this.state;

    const total = faqs.length;
    const totalPages = Math.max(1, Math.ceil(total / pageSize));
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = Math.min(startIndex + pageSize, total);
    const pageFaqs = faqs.slice(startIndex, endIndex);

    return (
      <div className='faq-page' style={{margin: '0px 10px'}}>
        {/* <Header /> */}
        <div className="faq-container">
          {/* Loading & error */}
          {loading && <p>Loading FAQs...</p>}
          {error && <p style={{ color: "red" }}>{error}</p>}

          {/* List */}
          {!loading && !error && total === 0 && <p>No FAQs available.</p>}

          {!loading && !error && total > 0 && (
            <>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={this.goToPage}
                total={total}
                startIndex={startIndex}
                endIndex={endIndex}
              />

              {/* Page content */}
              {pageFaqs.map((faq, index) => (
                <Accordion key={faq.id ?? `${startIndex + index}`} title={faq.question}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(this.decodeHTML(faq.answer)),
                    }}
                  />
                </Accordion>
              ))}
            </>
          )}
        </div>
      </div>
    );
  }
}

class Accordion extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false };
    this.toggleAccordion = this.toggleAccordion.bind(this);
  }

  toggleAccordion() {
    this.setState(prevState => ({ isOpen: !prevState.isOpen }));
  }

  render() {
    const { isOpen } = this.state;

    return (
      <div className="accordion-item">
        <div className="accordion-title" onClick={this.toggleAccordion}>
          {this.props.title}
          <img
            src={isOpen ? "./images/drop-up.png" : "./images/drop-down.png"}
            alt={isOpen ? "arrow up" : "arrow down"}
          />
        </div>
        {isOpen && <div className="accordion-content">{this.props.children}</div>}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ tokenAction }, dispatch);

const mapStateToProps = state => ({
  token: state.token,
  profile: state.profile
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(withRecoil(FAQ, [accessTokenState])));
